import { SERVER_URL } from "Static/constant";

// Account logos: the site's own icon from Salesgear's image service (/cm/img/logo/<domain>, which
// answers 404 when the site has no real icon), then the caller's initial. Stored logo URLs are ignored:
// they expire, and the icon service is the one source that is always current.

export const faviconUrl = domain => {
  const host = String(domain || "").trim().replace(/^https?:\/\//, "").replace(/\/.*$/, "");
  return host ? `${SERVER_URL}/cm/img/logo/${encodeURIComponent(host)}` : "";
};

// The URLs to try, in order (the stored logo is deliberately not one of them).
export const logoCandidates = (logo, domain) => [faviconUrl(domain)].filter(Boolean);

export const accountLogoUrl = (logo, domain) => logoCandidates(logo, domain)[0] || "";

// A tiny generic icon counts as no logo.
export const isPlaceholderIcon = img => Boolean(img) && img.naturalWidth > 0 && img.naturalWidth <= 16;
